/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum BoatHullMaterial {
    Gfk = 'Gfk',
    Holz = 'Holz',
    Carbon = 'Carbon',
    Stahl = 'Stahl',
    Andere = 'Andere'
  }

    export const BoatHullMaterialTranslocoMap: Record<BoatHullMaterial, string> = {
    [BoatHullMaterial.Gfk]: 'boatHullMaterial.gfk',
    [BoatHullMaterial.Holz]: 'boatHullMaterial.holz',
    [BoatHullMaterial.Carbon]: 'boatHullMaterial.carbon',
    [BoatHullMaterial.Stahl]: 'boatHullMaterial.stahl',
    [BoatHullMaterial.Andere]: 'boatHullMaterial.andere',
    };

    export const BoatHullMaterialOptions = [
  { value: BoatHullMaterial.Gfk, labelKey: 'boatHullMaterial.gfk' },
  { value: BoatHullMaterial.Holz, labelKey: 'boatHullMaterial.holz' },
  { value: BoatHullMaterial.Carbon, labelKey: 'boatHullMaterial.carbon' },
  { value: BoatHullMaterial.Stahl, labelKey: 'boatHullMaterial.stahl' },
  { value: BoatHullMaterial.Andere, labelKey: 'boatHullMaterial.andere' },
    ];

